export function preloadImage(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve()
    img.onerror = () => reject(new Error(`Failed to preload image: ${url}`))
    img.src = url
  })
}

export async function preloadFetch(url: string): Promise<void> {
  // Warm the browser cache. We don't care about the body, just that the request completes.
  const res = await fetch(url, { cache: 'force-cache' })
  if (!res.ok) throw new Error(`Failed to preload: ${url} (${res.status})`)
  // Some servers might stream; fully consume to make sure it's cached.
  await res.arrayBuffer()
}


